<template>
  <div>
    <!--notif jadwal-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            <h1
              class="headline black--text"
              v-html="`Daftar Akun Admin ${akses === 'admin-gtk' ? '' : 'Pusat'} GTK`"
            ></h1>
            <p v-html="desc"></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <list-admin
      jenis="admin"
      :akses="akses"
      :title="`Akun Admin ${akses === 'admin-gtk' ? '' : 'Pusat '} GTK`"
      desc=""
      :actions="listAksi"
    ></list-admin>
  </div>
</template>

<script>
import ListAdmin from '../base/Main';
import Actions from './actions';
export default {
  name: 'Program',
  components: { ListAdmin },
  data() {
    return {
      actions: Actions,
      desc: '',
    };
  },
  computed: {
    akses() {
      return this.$route.meta.tipe;
    },
    listAksi() {
      return this.akses === 'admin-gtk' ? Actions['admin'] : Actions['pusat'];
    },
  },
};
</script>

<style scoped></style>
